// extracted by mini-css-extract-plugin
module.exports = {"message":"AuthoringWarningMessage_message___LsLd"};